import { Route, Routes } from 'react-router-dom';

import companiesBg from '../../assets/images/company-hero-logo.png';
import dashboardBg from '../../assets/images/dashboard-hero-logo.png';
import faqBg from '../../assets/images/faq.png';
import propertiesBg from '../../assets/images/properties-hero-logo.png';
import { Onboarding } from '../Onboarding';
import { ONBOARDING_ENTITIES } from '../Onboarding/types';
import { Hero } from '../ui/Hero/Hero';
import { theme } from '../ui/themes/default';

export function RenderHero() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Hero
            image={dashboardBg}
            title="My Dashboard"
            subtitle="See your last activity"
            backgroundColor={theme.paleGrey}
            actions={<Onboarding entity={ONBOARDING_ENTITIES.DASHBOARD} />}
          />
        }
      />
      <Route
        path="/companies"
        element={
          <Hero
            image={companiesBg}
            title="Companies"
            subtitle="All companies you have access to"
            backgroundColor={theme.paleGrey}
          />
        }
      />
      <Route
        path="/faq"
        element={
          <Hero image={faqBg} title="FAQ" subtitle="Frequently Asked Questions" backgroundColor={theme.paleGrey} />
        }
      />
      <Route
        path="/procedures"
        element={<Hero image={companiesBg} title="Default Procedures" subtitle="" backgroundColor={theme.paleGrey} />}
      />
      <Route
        path="/properties"
        element={
          <Hero
            image={propertiesBg}
            title="Properties"
            subtitle="Property list that is available for you in the company"
            backgroundColor={theme.paleGrey}
          />
        }
      />
    </Routes>
  );
}
